__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "login";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@tanstack/react-query", "5.101.0", () => (__webpack_require__.e(8496).then(() => (() => (__webpack_require__(68496))))));
			register("axios", "1.20.0", () => (Promise.all([__webpack_require__.e(4330), __webpack_require__.e(2061)]).then(() => (() => (__webpack_require__(14330))))));
			register("dompurify", "3.4.8", () => (__webpack_require__.e(1746).then(() => (() => (__webpack_require__(61746))))));
			register("i18next", "25.10.10", () => (Promise.all([__webpack_require__.e(1174), __webpack_require__.e(4442)]).then(() => (() => (__webpack_require__(51174))))));
			register("next/compat/router", "15.5.18", () => (() => (__webpack_require__(64435))), 1);
			register("next/dynamic", "15.5.18", () => (__webpack_require__.e(9393).then(() => (() => (__webpack_require__(29393))))));
			register("next/head", "15.5.18", () => (() => (__webpack_require__(24358))), 1);
			register("next/image", "15.5.18", () => (__webpack_require__.e(8841).then(() => (() => (__webpack_require__(58841))))));
			register("next/link", "15.5.18", () => (() => (__webpack_require__(15084))), 1);
			register("next/router", "15.5.18", () => (() => (__webpack_require__(70629))), 1);
			register("next/script", "15.5.18", () => (__webpack_require__.e(5843).then(() => (() => (__webpack_require__(75843))))));
			register("react-dom", "19.1.0", () => (() => (__webpack_require__(24518))), 1);
			register("react-hook-form", "7.87.0", () => (__webpack_require__.e(2732).then(() => (() => (__webpack_require__(52732))))));
			register("react-i18next", "15.7.4", () => (__webpack_require__.e(8386).then(() => (() => (__webpack_require__(58386))))));
			register("react-lazily", "0.9.2", () => (__webpack_require__.e(1178).then(() => (() => (__webpack_require__(71178))))));
			register("react-phone-number-input", "0", () => (Promise.all([__webpack_require__.e(5541), __webpack_require__.e(4742)]).then(() => (() => (__webpack_require__(94742))))));
			register("react-phone-number-input", "0", () => (Promise.all([__webpack_require__.e(5541), __webpack_require__.e(2992)]).then(() => (() => (__webpack_require__(92992))))));
			register("react-tooltip", "5.30.1", () => (Promise.all([__webpack_require__.e(3288), __webpack_require__.e(6823)]).then(() => (() => (__webpack_require__(53288))))));
			register("stores/use-toast-store", "1.0.0", () => (() => (__webpack_require__(95445))), 1);
			register("zustand", "4.5.7", () => (() => (__webpack_require__(9971))), 1);
			register("react-dom/client", "19.1.0", () => (__webpack_require__.e(6593).then(() => (() => (__webpack_require__(72181))))));
			register("react/jsx-runtime", "19.1.0", () => (__webpack_require__.e(6593).then(() => (() => (__webpack_require__(44489))))));
			register("react", "19.1.0", () => (__webpack_require__.e(6593).then(() => (() => (__webpack_require__(44349))))));
			register("styled-jsx/style", "5.1.6", () => (__webpack_require__.e(19).then(() => (() => (__webpack_require__(10019))))));
			register("styled-jsx", "5.1.6", () => (__webpack_require__.e(7738).then(() => (() => (__webpack_require__(77738))))));
			initExternal(71305);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};